import "./style.scss";

function setCookie(key, value) {
  document.cookie = key + "=" + value + ";";
}

function getCookie(key) {
  const cookies = document.cookie;
  const cookiesAry = cookies.split(";");

  for (let i = 0; i < cookiesAry.length; i++) {
    let cookie = cookiesAry[i].split("=");
    if (cookie[0].trim(" ") == key) {
      return cookie;
    }
  }
}

new Vue({
  el: "#js-top__loading",
  data: {
    isShow: true,
    loadedBackground: false,
    loadedLogo: false,
    showLoadingFlug: false,
  },
  methods: {
    completeLoaded() {},
  },
  mounted() {
    const keyName = "top-visited";
    const keyValue = "true";
    const cookie = getCookie(keyName);
    if (typeof cookie === "undefined" || cookie[1] != keyValue) {
      this.showLoadingFlug = true;
    } else {
      console.log("visited");
      this.isShow = false;
    }
  },
  computed: {
    isLoadedContent() {
      return this.loadedBackground && this.loadedLogo && this.showLoadingFlug;
    },
  },
  watch: {
    isLoadedContent: function () {
      const keyName = "top-visited";
      const keyValue = "true";
      setCookie(keyName, keyValue);
      setTimeout(() => {
        this.isShow = false;
      }, 2500);
    },
  },
});
